import { notify } from 'notiwind'
import { translate } from '@/utils/translate'
// Import pop sound for notifications
import popSound from '@/assets/sfx/pop.mp3'
export function showNotification (data) {
  let duration = data.data.close_seconds * 1000 || 60000 // Default to 15 seconds in milliseconds
  let closeable = false
  const requireInteraction = data.data.require_interaction || false

  // If hover or interaction required, set duration to infinity (or a high number)
  if (requireInteraction) {
    duration = -1
    closeable = true
  }
  let notification = {
    group: 'ndj', // Custom notification group
    type: data.type,
    title: '',
    badge: false,
    clickable: false,
    text: '',
    button_text: translate('Click here'),
    requireInteraction: requireInteraction,
    closeable: closeable, // Add a close button when interaction is required
    onClick: data.data.onClick || (() => {})
  }

  switch (data.type) {
    case 'video':
      notification.title = data.video.title
      notification.text = data.video.excerpt
      notification.videoUrl = data.video.embed
      notification.button_text = translate('Go to video')
      notification.onClick =
        data.onClick || (() => window.open(data.video.url, '_blank'))
      break

    case 'invite':
      notification.title = data.event.title
      notification.badge = data.event.type.name // 'webinar, konferencja, szkolenie'
      notification.text = data.event.excerpt
      notification.image = data.event.images.thumbnail?.medium?.url
      notification.url = data.event.url
      notification.button_text = translate('Join Event')
      notification.clickable = true
      notification.onClick =
        data.onClick || (() => window.open(data.event.url, '_blank'))
      break

    case 'image':
      notification.title = translate('Image Notification')
      notification.text = translate('An image has been shared with you.')
      notification.image = data.data.image.banner
      notification.clickable = true
      
      if (data.data.notification_url) {
        notification.onClick = function() {
          window.open(data.data.notification_url, '_blank')
        }
      } else {
        notification.onClick = function() {
          window.open(data.data.image.original, '_blank')
        }
      }
      break

    case 'download':
      notification.title = translate('File Download')
      notification.button_text = translate('Click here to download')
      notification.clickable = true
      notification.text = translate(
        'By clicking to button below you can download the file.'
      )
      notification.onClick =
        data.onClick || (() => window.open(data.data.file, '_blank'))
      break

    case 'button':
      notification.title = translate('Action Required')
      notification.text = data.data.button_text
      notification.clickable = true
      notification.onClick =
        data.onClick ||
        (() => window.open(data.data.notification_url, '_blank'))
      break

    case 'notification':
      notification.title = data.data.title || 'Notification'
      notification.text = data.data.content || ''
      notification.image = data.data.image?.banner || false
      notification.url = data.data.notification_url
      if (data.data.notification_url) {
        notification.clickable = true
        notification.onClick = function() {
          window.open(data.data.notification_url, '_blank')
        }
      }
      break

    default:
      notification.title = 'Unknown Notification'
      notification.text = 'You have received a new notification.'
      break
  }

  // Execute the notiwind notify function with the configured notification data
  notify(notification, duration)
  
  // Play notification sound
  const audio = new Audio(popSound)
  audio.volume = 0.5
  audio.play().catch(err => console.error('Error playing notification sound:', err))
}
